export default __webpack_public_path__ + "static/media/as.ccfcc5a3.svg";